<script lang="ts">
import IconChatbot from '@/components/icons/IconChatbot.svelte'
import { testIds } from '@/constants'

import Avatar from './Avatar.svelte'
</script>

<Avatar icon={IconChatbot} testId={testIds.avatarBot} />
